import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ApiRequest, ShowLoader } from 'GlobalFunctions';
import { useSnackbar } from "notistack";
import { useEffect, useState, useRef } from 'react';


const CheckoutForm = (props: any) => {
    const { setPaymentStatus } = props;
    const stripe = useStripe();
    const elements = useElements();
    const handlerRef = useRef<((e: Event) => void) | null>(null);
    
    // Use refs to always access the latest stripe/elements values
    const stripeRef = useRef(stripe);
    const elementsRef = useRef(elements);
    
    // Keep refs updated when stripe/elements change
    useEffect(() => {
        stripeRef.current = stripe;
        elementsRef.current = elements;
        console.log('Stripe/Elements updated:', !!stripe, !!elements);
    }, [stripe, elements]);
    
    const handleClick = async () => {
        ShowLoader(true);

        const currentStripe = stripeRef.current;
        const currentElements = elementsRef.current;

        if (!currentStripe || !currentElements) {
            console.error('Stripe or Elements not loaded.');
            ShowLoader(false);
            return;
        }

        const { error, paymentIntent } = await currentStripe.confirmPayment({
            elements: currentElements,
            confirmParams: {
                return_url: window.location.href,
            },
            redirect: 'if_required'
        });

        if (error) {
            setPaymentStatus({ status: 'error', message: "Payment failed" });
            
        } else if (paymentIntent) {
            if (paymentIntent.status === 'succeeded') {
                const subscription_data = JSON.parse(localStorage.getItem('subscription') || '{}');

                await ApiRequest({
                    url: "/payments/subscriptionCheckout",
                    method: "post",
                    body: {
                        subscription_data,
                        payment_method: 'stripe',
                        paymentIntent
                    },
                    setResponse: (response: any) => {
                        setPaymentStatus(response);
                    }
                });
            } else {
                // console.log('Payment not completed: ', paymentIntent.status);
            }
            
        }

        ShowLoader(false);
    };

    // Attach click handler to the existing add-btn button inside subscription form
    useEffect(() => {
        // Find the add-btn inside the subscription form specifically
        const subscriptionForm = document.querySelector('[pc="subscription-form"]');
        const addButton = subscriptionForm?.querySelector('[pc="add-btn"]');
        
        console.log('=== StripeForm useEffect (mount) ===');
        console.log('subscriptionForm found:', subscriptionForm);
        console.log('addButton found:', addButton);
        
        if (addButton) {
            // Remove previous handler if exists
            if (handlerRef.current) {
                addButton.removeEventListener('click', handlerRef.current);
            }
            
            // Create new handler - uses refs to get latest stripe/elements
            handlerRef.current = (e: Event) => {
                console.log('=== StripeForm click handler TRIGGERED ===');
                e.preventDefault();
                e.stopPropagation();
                
                // Check refs for current stripe/elements values
                console.log('stripeRef.current:', !!stripeRef.current);
                console.log('elementsRef.current:', !!elementsRef.current);
                
                if (!stripeRef.current || !elementsRef.current) {
                    console.error('Stripe or Elements not ready yet');
                    return;
                }
                
                handleClick();
            };
            
            console.log('Adding click handler to add-btn');
            addButton.addEventListener('click', handlerRef.current);
        }
        
        // Cleanup on unmount
        return () => {
            const subscriptionForm = document.querySelector('[pc="subscription-form"]');
            const addButton = subscriptionForm?.querySelector('[pc="add-btn"]');
            if (addButton && handlerRef.current) {
                addButton.removeEventListener('click', handlerRef.current);
            }
        };
    }, []); // Empty deps - run once on mount

    return (
        <div>
            <PaymentElement />
        </div>
    );
};

const StripeForm = (props: any) => {

    const appearance = {
        theme: 'flat' as 'stripe' | 'night' | 'flat', 
        labels: 'floating' as 'floating' | 'above',  
        variables: {
            fontFamily: 'Arial, sans-serif',
            spacingUnit: '4px',
            borderRadius: '5px',
        },
        rules: {
            '.Label': {
            },
            '.Input': {
                borderColor: '#ced4da',
            },
            '.Error': {
                color: '#dc3545',
            },
        },
    };
    const { 
        payment_settings: {
            public_key,
            client_secret: clientSecret
        }, 
        setPaymentStatus 
    } = props;


    const stripePromise = loadStripe(public_key);


    return (
        <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
            <CheckoutForm setPaymentStatus={setPaymentStatus} />
        </Elements>
    );
};

export default StripeForm;
